import React from 'react';
import {Grid} from '@material-ui/core';
import {RouteComponentProps, withRouter} from 'react-router';
import './Dashboard.sass';

type TileValues = {
  subTitle: string;
  count: string | number;
};

type DashboardCardProps = {
  title: string;
  iconName: string;
  cardContents: TileValues[];
  onClick?: () => void;
  id: string;
} & RouteComponentProps;

const DashboardCard = (props: DashboardCardProps) => {
  const {title, iconName, cardContents, onClick, id} = props;

  return (
    <Grid item xs={12} sm={6} md={4} lg={4} xl={3}>
      <div className="enrollment-dashboard__enrollment-file-card" onClick={onClick}>
        <div className="enrollment-file-card">
          <div className="enrollment-file-card__title-container">
            <Grid container justify="space-between">
              <Grid item md={10} xs={9}>
                <div className="title-container--item">
                  <h3 id={`enrollment-file-card-title-${id}`} className="title-container--item-title">
                    {title}
                  </h3>
                </div>
              </Grid>
              <Grid item container md={2} xs={3} justify="flex-end">
                <div className={`title-container--item__icon-container ${iconName}`}>
                  <i className={`enrollment-file-card__icon icon--${iconName}`}></i>
                </div>
              </Grid>
            </Grid>
          </div>
          <div className="enrollment-file-card__statistics-container">
            {cardContents.map((cardContent, index) => (
              <div key={cardContent.subTitle} className="statistics-container--item three-stack">
                <h4
                  id={`enrollment-file-card-statistics-title-${id}-${index}`}
                  className="statistics-container--item-title"
                >
                  {cardContent.subTitle}
                </h4>
                <p
                  id={`enrollment-file-card-statistics-value-${id}-${index}`}
                  className="statistics-container--item-value"
                >
                  {cardContent.count}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Grid>
  );
};

export default withRouter(DashboardCard);
